import Vue from 'vue';
import {Vue as _Vue} from "vue/types/vue";
import {VRadioGroup} from "vuetify/lib";

const radioGroup = VRadioGroup as unknown as typeof _Vue;

export default Vue.extend({
	name: 'AsiRadioGroup',
	extends: radioGroup,
	props: {
		hideDetails: {
			type: String,
			default: 'auto',
		},
		column: {
			type: Boolean,
			default: true,
		},
		rules: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		classes(): Record<string, boolean> {
			const base = (this as any).$options.extends.options.computed.classes.call(this);
			const hasRequired = this.rules.some((rule: any) => rule?.isRequired);

			return {
				...base,
				'input-required': hasRequired,
			};
		},
	},
});
